import React from 'react';
import { noop } from 'lodash-es';

export const OverviewContext = React.createContext({ expandedItems: {}, toggleItem: noop });
